import { render, staticRenderFns } from "./maritalstatus.vue?vue&type=template&id=e1f4230c&"
import script from "./maritalstatus.vue?vue&type=script&lang=js&"
export * from "./maritalstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports